<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{ $t('website_facebook') }}</label>
          <input class="form-control"
                 type="text"
                 name="website"
                 v-validate="'url'"
                 v-model="model.website"
                 url="true"
                 placeholder="ex: http://www.yoursite.com"
          />
          <small class="text-danger" v-show="website.invalid">
            {{ getError('website') }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="form-group">
          <label class="control-label">{{ $t('company_name') }}</label>
          <input class="form-control"
                 type="text"
                 name="company"
                 v-model="model.company"
                 v-validate="{required: model.isCompany}"
                 placeholder="ex: Acme Ltd."
          />
        </div>
      </div>
      <div class="col-md-2">
          <label class="control-label">{{ $t('company') }}?</label>
          <p-switch v-model="model.isCompany" value="true" name="isCompany" type="primary" on-text="YES" off-text="NO"></p-switch>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">{{ $t('vat_tax_number') }}</label>
          <input class="form-control"
                 type="text"
                 name="vat_number"
                 v-model="model.vat_number"
                 :placeholder="$t('vat_is_required')"
                 v-validate="'required'"
                 minlength="5"
          />
          <small>{{ $t('dont_enter_valid_vat_vat_applied') }}.</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">
            {{ $t('country') }}
          </label>
          <select name="country"
                  v-validate="'required'"
                  v-model="model.country"
                  class="form-control"
                  placeholder="Select country please">
            <option selected value="">- {{ $t('select_country') }} -</option>
            <option v-for="country in countryData" :value="country.code" :key="country.code">{{country.name}}</option>
          </select>
          <small class="text-danger" v-show="country.invalid">
            {{ getError('country') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import PSwitch from "src/components/UIComponents/Switch.vue";
  export default {
      components: {
    PSwitch
  },
    computed: {
      ...mapFields(['website', 'country', 'company', 'isCompany', 'vat'])
    },
    mounted: function() {
      this.fillCountries();
    },
    data () {
      return {
        countryData: {},
        model: {
          website: '',
          isCompany: true,
          company: '',
          vat: '',
          country: ''
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      },
      fillCountries() {
        this.countryData = General.getAllCountries();
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register/SecondStep.vue